/* TEMPO — interactions page produit (panier = drawer natif du thème) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initIcons() {
    if (window.lucide && window.lucide.createIcons) {
      window.lucide.createIcons();
    } else {
      setTimeout(initIcons, 100);
    }
  }

  ready(function () {
    initIcons();

    /* ----- Menu mobile ----- */
    var burger = document.querySelector('[data-burger]');
    var mobileNav = document.querySelector('[data-mobilenav]');
    if (burger && mobileNav) {
      burger.addEventListener('click', function () { mobileNav.classList.toggle('open'); });
      mobileNav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { mobileNav.classList.remove('open'); });
      });
    }

    /* ----- Galerie produit ----- */
    var gallery = document.querySelector('[data-gallery]');
    if (gallery) {
      var mainImg = gallery.querySelector('[data-gallery-main]');
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
      var idx = 0;
      function show(i) {
        idx = (i + thumbs.length) % thumbs.length;
        var t = thumbs[idx];
        mainImg.src = t.getAttribute('data-full');
        mainImg.alt = t.querySelector('img') ? t.querySelector('img').alt : '';
        thumbs.forEach(function (th, j) { th.classList.toggle('active', j === idx); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
    }

    /* ----- Sélecteur de packs ----- */
    var packs = Array.prototype.slice.call(document.querySelectorAll('[data-pack]'));
    var priceEl = document.querySelector('[data-hero-price]');
    var oldEl = document.querySelector('[data-hero-old]');
    var saveEl = document.querySelector('[data-hero-save]');
    var cta = document.querySelector('[data-cta]');
    var tooltip = document.querySelector('[data-tooltip]');
    var stickyPack = document.querySelector('[data-sticky-pack]');
    var stickyCta = document.querySelector('[data-sticky-cta]');
    var stickyTooltip = document.querySelector('[data-sticky-tooltip]');

    if (cta) cta.textContent = 'AJOUTER AU PANIER';
    if (stickyCta) stickyCta.textContent = 'Ajouter au panier';

    function currentPack() {
      return packs.filter(function (p) { return p.classList.contains('selected'); })[0] || null;
    }

    function refreshCta() {
      var p = currentPack();
      if (!p || !cta) return;
      var selects = Array.prototype.slice.call(p.querySelectorAll('select'));
      var all = selects.every(function (s) { return s.value !== ''; });
      cta.disabled = !all;
      if (tooltip) tooltip.classList.toggle('show', !all);
      if (stickyCta) stickyCta.disabled = !all;
      if (stickyTooltip) stickyTooltip.classList.toggle('show', !all);
    }

    function refreshSticky(p) {
      if (!stickyPack || !p) return;
      var count = parseInt(p.getAttribute('data-count'), 10) || 1;
      stickyPack.textContent = p.getAttribute('data-title') + ' · ' + count + ' culotte' + (count > 1 ? 's' : '');
    }

    function selectPack(p) {
      packs.forEach(function (x) { x.classList.toggle('selected', x === p); });
      if (priceEl) priceEl.textContent = p.getAttribute('data-price') + ' DT';
      var old = p.getAttribute('data-old-price');
      if (oldEl) {
        oldEl.style.display = old ? '' : 'none';
        if (old) oldEl.textContent = old + ' DT';
      }
      if (saveEl) {
        saveEl.style.display = old ? '' : 'none';
        if (old) saveEl.textContent = 'Économisez ' + (parseInt(old, 10) - parseInt(p.getAttribute('data-price'), 10)) + ' DT';
      }
      p.querySelectorAll('select').forEach(function (s) { s.value = ''; });
      refreshSticky(p);
      refreshCta();
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION' || e.target.tagName === 'LABEL') return;
        selectPack(p);
      });
      p.querySelectorAll('select').forEach(function (s) {
        s.addEventListener('change', refreshCta);
        s.addEventListener('click', function (e) { e.stopPropagation(); });
      });
    });
    refreshSticky(currentPack());
    refreshCta();

    /* ----- Guide des flux ----- */
    var fluxTabs = Array.prototype.slice.call(document.querySelectorAll('[data-flux-tab]'));
    var fluxPanel = document.querySelector('[data-flux-panel]');
    if (fluxTabs.length && fluxPanel) {
      var fluxRect = fluxPanel.querySelector('[data-flux-rect]');
      var fluxAnim = null;

      function tabFill(tab) {
        var v = parseFloat(tab.getAttribute('data-fill'));
        if (isNaN(v)) {
          var lbl = (tab.getAttribute('data-label') || tab.textContent || '').toLowerCase();
          if (lbl.indexOf('léger') > -1 || lbl.indexOf('leger') > -1) v = 25;
          else if (lbl.indexOf('abondant') > -1) v = 100;
          else v = 60;
        }
        return v;
      }

      function setLevel(v) {
        if (!fluxRect) return;
        fluxRect.setAttribute('y', (100 - v));
        fluxRect.setAttribute('height', v);
      }

      var activeTab = fluxTabs.filter(function (t) { return t.classList.contains('active'); })[0] || fluxTabs[0];
      var fluxCurrent = tabFill(activeTab);
      setLevel(fluxCurrent);

      function animateFill(target) {
        if (!fluxRect || isNaN(target)) return;
        if (fluxAnim) cancelAnimationFrame(fluxAnim);
        var from = fluxCurrent;
        var delta = target - from;
        if (Math.abs(delta) < 0.5) { setLevel(target); fluxCurrent = target; return; }
        var duration = 800;
        var start = null;
        function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var v = from + delta * ease(p);
          setLevel(v);
          fluxCurrent = v;
          if (p < 1) fluxAnim = requestAnimationFrame(step);
          else { fluxCurrent = target; fluxAnim = null; }
        }
        fluxAnim = requestAnimationFrame(step);
      }

      fluxTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          fluxTabs.forEach(function (t) { t.classList.toggle('active', t === tab); });
          animateFill(tabFill(tab));
          fluxPanel.querySelector('[data-flux-ml]').textContent = tab.getAttribute('data-ml');
          fluxPanel.querySelector('[data-flux-equiv]').textContent = tab.getAttribute('data-equiv');
          fluxPanel.querySelector('[data-flux-label]').textContent = tab.getAttribute('data-label');
          fluxPanel.querySelector('[data-flux-desc]').textContent = tab.getAttribute('data-desc');
          var iconWrap = fluxPanel.querySelector('[data-flux-icon]');
          iconWrap.innerHTML = '<span class="t-icon t-icon--28"><i data-lucide="' + tab.getAttribute('data-icon') + '"></i></span>';
          if (window.lucide) window.lucide.createIcons();
        });
      });
    }

    /* ----- Modales (guide des tailles) ----- */
    var modalOverlay = document.querySelector('[data-overlay]');
    function closeModals() {
      document.querySelectorAll('.t-modal.open').forEach(function (m) { m.classList.remove('open'); });
      if (modalOverlay) modalOverlay.classList.remove('open');
    }
    document.querySelectorAll('[data-open-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = document.getElementById(btn.getAttribute('data-open-modal'));
        if (m) { closeModals(); m.classList.add('open'); if (modalOverlay) modalOverlay.classList.add('open'); }
      });
    });
    document.querySelectorAll('[data-close-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeModals);
    });
    if (modalOverlay) modalOverlay.addEventListener('click', closeModals);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModals(); });

    /* ----- Ajout au panier → drawer NATIF du thème ----- */
    var nativeDrawer = document.querySelector('cart-drawer');

    function openNativeDrawer(parsed) {
      try {
        if (nativeDrawer && typeof nativeDrawer.renderContents === 'function' && parsed && parsed.sections) {
          nativeDrawer.renderContents(parsed);
          return;
        }
      } catch (e) { /* fallback below */ }
      /* secours : recharge la page section panier */
      window.location.href = '/cart';
    }

    function addToCart() {
      var p = currentPack();
      if (!p) return;
      var selects = Array.prototype.slice.call(p.querySelectorAll('select'));
      var sizes = selects.map(function (s) { return s.value; });
      if (sizes.some(function (v) { return v === ''; })) return;
      var map = null;
      try { map = JSON.parse(p.getAttribute('data-variants') || 'null'); } catch (err) { map = null; }
      var variantId = map && sizes.length ? map[sizes[0]] : null;
      if (!variantId) { window.location.href = '/cart'; return; }

      var payload = {
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };
      if (selects.length > 1) {
        var properties = {};
        selects.forEach(function (s, i) { properties['Taille Culotte ' + (i + 1)] = s.value; });
        payload.items[0].properties = properties;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (parsed) {
        openNativeDrawer(parsed);
      }).catch(function () { window.location.href = '/cart'; });
    }

    if (cta) cta.addEventListener('click', function () { if (!cta.disabled) addToCart(); });
    if (stickyCta) stickyCta.addEventListener('click', function () { if (!stickyCta.disabled) addToCart(); });
  });
})();
